// ============================================================================
// Type Guards
// ============================================================================
/**
 * Type guard for a player in a round of either Hide and Seek game type: for
 * what both play the same way (Marco Polo, disqualification, scores).
 */
export function isHideSeekRoundPlayer(player) {
    return 'role' in player && (player.role === 'hider' || player.role === 'seeker');
}
/**
 * Type guard to check if a round player is a Hide and Seek player
 * Checks for HNS-specific fields
 */
export function isHnsRoundPlayer(player) {
    return isHideSeekRoundPlayer(player) && !('team' in player);
}
/**
 * Type guard to check if a round player is a Hide and Seek Teams player
 */
export function isHnstRoundPlayer(player) {
    return isHideSeekRoundPlayer(player) && 'team' in player;
}
/**
 * Whether a Hide and Seek Teams hider is out of the round: caught, or
 * disqualified.
 */
export function isHnstPlayerOut(player) {
    return player.capturedAt != null || isHnsPlayerDisqualified(player);
}
/**
 * Type guard to check if a round player is an FP Race player
 * Checks for FPR-specific fields (absence of role field)
 */
export function isFprRoundPlayer(player) {
    return !('role' in player) || player.teamId !== undefined;
}
/**
 * Type guard to check if a round player is a Trailblazers player.
 * Checks for the TRL-specific `hasCaptured` marker.
 */
export function isTrlRoundPlayer(player) {
    return !('role' in player) && 'hasCaptured' in player;
}
/**
 * Check if a Hide and Seek (or Hide and Seek Teams) round player is disqualified
 */
export function isHnsPlayerDisqualified(player) {
    return player.disqualification?.disqualified === true;
}
/**
 * Check if any round player is disqualified (works for types that support it)
 */
export function isPlayerDisqualified(player) {
    if (isHideSeekRoundPlayer(player)) {
        return isHnsPlayerDisqualified(player);
    }
    return false;
}
/**
 * Get player display name from their player ID: their character name, else
 * their Discord username (e.g. a player from a sign-up who hasn't joined yet),
 * else their abbreviated player ID.
 */
export function getPlayerDisplayName(playerId, players) {
    const player = players.find(p => p.playerId === playerId);
    if (player?.characterName)
        return player.characterName;
    if (player?.discord?.discordUsername)
        return `@${player.discord.discordUsername}`;
    return `Player ${playerId.slice(-4)}`;
}
